/* eslint-disable max-len */
const ArrowRightUpCircle = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_566_7271)">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5308 8.0015L15.5308 8.00124C15.5308 3.8409 12.1591 0.469151 7.99876 0.469151C3.83841 0.469151 0.466666 3.8409 0.466666 8.00124C0.466666 12.1616 3.83841 15.5333 7.99876 15.5333C12.1593 15.5333 15.5332 12.1614 15.5308 8.0015ZM-3.49637e-07 8.00124C-1.56516e-07 12.4193 3.58068 16 7.99876 16C12.4168 16 16 12.4193 15.9975 8.00124C15.9975 3.58316 12.4168 0.00248362 7.99876 0.00248381C3.58068 0.00248401 -5.42757e-07 3.58316 -3.49637e-07 8.00124Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5.51392 4.97068L11.6481 4.97068L11.6481 11.1048L11.1481 11.1048L11.1481 5.47068L5.51392 5.47068L5.51392 4.97068Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2.48462 13.7807L11.2214 5.0439L11.5749 5.39746L2.83817 14.1342L2.48462 13.7807Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_566_7271">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowRightUpCircle;
